import { iconButtonClasses, inputAdornmentClasses, menuItemClasses, paperClasses, useTheme } from '@mui/material';
import { pickersInputBaseClasses, pickersOutlinedInputClasses, pickersLayoutClasses, TimePicker, TimePickerProps, multiSectionDigitalClockClasses, multiSectionDigitalClockSectionClasses } from '@mui/x-date-pickers';

export interface DeliveryTimePickerProps {
  timePickerProps: TimePickerProps;
  error?: boolean;
}

export default function DeliveryTimePicker({ timePickerProps, error }: DeliveryTimePickerProps): React.JSX.Element {
  const theme = useTheme();

  return (
    <TimePicker
      {...timePickerProps}
      slotProps={{
        inputAdornment: {
          position: 'start',
        },
        textField: {
          error,
          sx: {
            [`& .${inputAdornmentClasses.root}`]: {
              ml: 0,
              mr: 1,
              [`& .${iconButtonClasses.root}`]: {
                color: theme.palette.onSurfaceVariant.main,
              },
            },
            [`& .${pickersInputBaseClasses.root}`]: {
              borderRadius: 3,
              flexDirection: 'row-reverse',
              px: 0.5,
              py: 0,
            },
            [`& .${pickersInputBaseClasses.focused} .${pickersOutlinedInputClasses.notchedOutline}`]: {
              // !important is here to overload the value defined by the default component
              borderWidth: '3px!important',
            },
          },
        },
        digitalClockSectionItem: {
          sx: {
            // !important is here to overload the value defined by the default component
            borderRadius: '4px !important',

            '&.Mui-selected': {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
              },
              '&::after': {
                content: 'none',
                display: 'none',
              },
            },
            [`&.${menuItemClasses.selected}`]: {
              backgroundColor: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
              },
              '&::after': {
                display: 'none',
              },
            },
          },
        },
        popper: {
          sx: {
            [`& .${paperClasses.root} .${pickersLayoutClasses.root}`]: {
              display: 'block',
            },
            [`& .${paperClasses.root} .${multiSectionDigitalClockClasses.root}`]: {
              width: '100%',
            },
            [`& .${paperClasses.root} .${multiSectionDigitalClockSectionClasses.root}`]: {
              width: '100%',
            },
            [`& .${paperClasses.root} .${multiSectionDigitalClockSectionClasses.item}`]: {
              width: '100%',
              px: 0,
              mx: 0,
            },
          },
        },
      }}
    />
  );
}
